import { create } from 'zustand';

import { send } from '@/api/send';
import type { ReportData, ScheduleEntity } from '@/api/types';

type ReportsState = {
  dashboardId: string;
  widgets: ReportData[];
  loading: boolean;
  load: () => Promise<void>;
};

export const useReportsStore = create<ReportsState>((set, get) => ({
  dashboardId: 'main',
  widgets: [],
  loading: false,
  async load() {
    set({ loading: true });
    const widgets = await send('reports-get-data', {
      dashboardId: get().dashboardId,
    });
    set({ widgets, loading: false });
  },
}));

type SchedulesState = {
  schedules: ScheduleEntity[];
  loading: boolean;
  filter: string;
  setFilter: (value: string) => void;
  load: () => Promise<void>;
};

export const useSchedulesStore = create<SchedulesState>(set => ({
  schedules: [],
  loading: false,
  filter: '',
  setFilter(value) {
    set({ filter: value });
  },
  async load() {
    set({ loading: true });
    const schedules = await send('schedules-get');
    set({ schedules, loading: false });
  },
}));
